<template>
  		<div v-if="this.$route.name !== 'InvoiceViewer'" class="footer">
			<!-- <div id="extra-space" :style="`min-height:${extraSpace}px;`"></div> -->
			<div id="extra-space"></div>
  			<footer id="footer">
				<div class="boxed_width">
					<div class="footer_top">
						<div class="footer_top_inner">


							<!-- <p class="ftb_right">Got Questions? <a href="tel:800-342-4537">800.342.4537</a> or <span class="chat" @click="chat()">Chat</span></p>
							<p class="ftb_right_mob"><span>Got Questions?</span><span><a href="tel:800-342-4537">Call</a> or <span class="chat" @click="chat()">Chat</span></span></p> -->
							
							
							<p class="ftb_right">Got Questions? <span class="chat" @click="chat()">Chat</span></p>
							<p class="ftb_right_mob"><span>Got Questions?</span><span><span class="chat" @click="chat()">Chat</span></span></p>
							<div class="ftb_left footer_social_wrap">
								<div class="currency-wrapper">
									<currency-selector/>
									<p class="divider"></p>
									<p>Let's Connect</p>
								</div>
								<div class="fsw_icons">
									<!-- <a href="https://wa.me/17188749771" target="_blank">
										<img target="_blank" src="/img/whatsapp.svg" width="30" alt="whatsapp_icon">
									</a> -->
									<a href="https://www.instagram.com/eichlersbp/" target="_blank">
										<img target="_blank" src="/img/instagram.svg" width="32" alt="instagram_icon">
									</a>
									<!-- <a href="">
										<img target="_blank" src="/img/twitter.svg" width="34">
									</a> -->
								</div>
							</div>
						</div>
					</div>
					<div class="footer_cols_section">

						<div class="tab-currency-wrapper">
							<currency-selector/>
						</div>

						<div class="footer_cols_section_inner">
							<div class="fcs_col fcs_sitemap">
								<p class="fcs_ttl">Company</p>
								<a class="fcs_txt links" href="/about/43">About</a>
								<router-link class="fcs_txt links" :to="{name:'ContactUs'}">Contact</router-link>
								<router-link class="fcs_txt links" :to="{name:'StoreHours'}">Store Hours</router-link>
								<router-link class="fcs_txt links" :to="{name:'StoreAddress'}">Store Address</router-link>
							</div>
							<div v-if="false" class="fcs_col fcs_apps">
								<p class="fcs_ttl">Get The Eichlers App</p>
								<div class="fcsa_images">
									<a href="">
										<img src="img/app_store.png" width="130">
									</a>
									<a href="">
										<img src="img/play_store.png" width="130">
									</a>
								</div>
							</div>
							<div class="fcs_col fcs_shipping">
								<p class="fcs_ttl">Shipping</p>
								<p class="fcs_txt">{{freeShippingMsg}}<a style="display:block;" href="/shipping-policy/41">Details</a></p>
							</div>
							<div class="fcs_col fcs_returns">
								<p class="fcs_ttl">Returns</p>
								<p class="fcs_txt">Shop With Confidence Easy 30-Day Return Policy <a href="/return-policy/42">Details</a></p>
							</div>
							<div class="fcs_col fcs_subscribe">
								<p class="fcs_ttl">Sign up for Eichlers news and special offers</p>
								<p class="fcs_ttl sub_ttl_mob">Let's keep in touch</p>
		
								<form id="subForm" class="footer_sub_form js-cm-form" action="https://www.createsend.com/t/subscribeerror?description=" method="post" data-id="92D4C54F0FEC16E5ADC2B1904DE9ED1AA4429AD2B3854061BD92C68418BBB7E5206200E2256619921B69C0772F8D34C47B8964BC375D864547481C681151FD9F">	
									<!-- <p> -->
										<!-- <label for="fieldEmail">Email</label>
										<br /> -->
										<input id="fieldEmail" name="cm-yhtikjh-yhtikjh" type="email" class="fsf_input fsfi_email js-cm-email-input pcl_input_text" placeholder="Email Address"
										required />
									<!-- </p>
									<p> -->
										<button class="fsf_input fsfi_btn js-cm-submit-button" type="submit">Sign Up</button>
									<!-- </p> -->
								</form>
							
								<!-- <form class="footer_sub_form">
									<input type="email" class="fsf_input fsfi_email" name="" placeholder="Email Address">
									<button type="submit" class="fsf_input fsfi_btn">Sign Up</button>
								</form> -->
							</div>
							<div class="ftb_left footer_social_wrap tab_social">
								<p>Let's Connect</p>
								<div class="fsw_icons">
									<!-- <a href="https://wa.me/17188749771">
										<img target="_blank" src="/img/whatsapp.svg" width="30">
									</a> -->
									<a href="https://www.instagram.com/eichlersbp/">
										<img target="_blank" src="/img/instagram.svg" width="32">
									</a>
									<!-- <a href="">
										<img target="_blank" src="/img/twitter.svg" width="34">
									</a> -->
								</div>
							</div>
						</div>
					</div>
					<div class="footer_bottom">
						<div class="footer_bottom_inner">
							<p class="ftb_right footer_bottom_text">Copyright &copy; {{new Date().getFullYear()}} Eichlers Online, Inc</p>
							<div class="ftb_left footer_social_wrap">
								<a href="/terms-of-use/39" class="footer_bottom_text fbt_links">Terms of Use</a>
								<a href="/privacy-policy/40" class="footer_bottom_text fbt_links">Privacy Policy</a>
							</div>
						</div>
					</div>
				</div>
			</footer>
  		</div>
</template>

<script>
import CurrencySelector from './CurrencySelector'
import CurrencyField from './CurrencyField'
import {mapGetters} from 'vuex'
export default {
	data(){
		return{
			extraSpace:0
		}
	},
	computed:{
		...mapGetters({
			freeShipping:'shippingRates/freeShipping',
		}),
		freeShippingMsg(){
			return this.freeShipping ? 
				`Free Shipping over ${'$' + this.freeShipping} on Most Orders `
				:'Fast and easy shipping options available around the world'
		}	
	},
	methods:{
		chat(){
			Beacon('open')
		},
	},

	components:{
		CurrencySelector,
		CurrencyField
	}
}
</script>

<style scoped>
footer{
	position: absolute;
	right: 0;
	left: 0;
	bottom: 0;
}
.links:hover{
	color: #016145;
}
.chat{
	color: #016145;
	cursor: pointer;	
}
.currency-wrapper{
	display: flex;
    align-items: center;
}
.divider{
	height: 21px;
	border-right: #F9A73C solid 1px;
	margin-right: 27px;
	margin-left: 27px;
	width: 1px;
}
.tab-currency-wrapper{
	display: none;
}
@media only screen and (max-width: 959px){
	.tab-currency-wrapper{
		margin-bottom: 40px;
		text-align: center;
		margin-top: 15px;
		display: block;
	}
	/* footer{
		bottom: initial;
	} */
	/* #extra-space{
		min-height: initial;
	} */
}
</style>


// WEBPACK FOOTER //
// resources/js/components/footer/Ffooter.vue